import client, { getSessionId, apiErrorMessage } from './client';

// Auth
export const login = (username, password) =>
  client.post('/auth/login', { username, password }).then((r) => r.data);
export const me = () => client.get('/auth/me').then((r) => r.data);

// Public
export const fetchProducts = (params = {}) =>
  client.get('/products', { params }).then((r) => r.data);
export const fetchArticles = (params = {}) =>
  client.get('/articles', { params }).then((r) => r.data);
export const fetchArticle = (slug) =>
  client.get(`/articles/${slug}`).then((r) => r.data);
export const fetchBranches = () => client.get('/branches').then((r) => r.data);
export const fetchSettings = (params = {}) =>
  client.get('/settings', {
    params,
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  }).then((r) => r.data);


// Tracking
export const trackVisit = (page) =>
  client.post('/analytics/visit', {
    page,
    session_id: getSessionId(),
    referrer: document.referrer,
    user_agent: navigator.userAgent.slice(0, 200),
  }).catch(() => null);

export const trackEvent = (type, meta = {}, page = window.location.pathname) =>
  client.post('/analytics/event', {
    type,
    meta,
    page,
    session_id: getSessionId(),
    user_agent: navigator.userAgent.slice(0, 200),
  }).catch(() => null);

// Admin — update/delete pakai POST (hosting sering blokir PUT/DELETE)
export const adminCreateProduct = (data) => client.post('/admin/products', data).then((r) => r.data);
export const adminUpdateProduct = (id, data) => client.post(`/admin/products/${id}`, data).then((r) => r.data);
export const adminDeleteProduct = (id) => client.post(`/admin/products/${id}/delete`).then((r) => r.data);

export const adminCreateArticle = (data) => client.post('/admin/articles', data).then((r) => r.data);
export const adminUpdateArticle = (id, data) => client.post(`/admin/articles/${id}`, data).then((r) => r.data);
export const adminDeleteArticle = (id) => client.post(`/admin/articles/${id}/delete`).then((r) => r.data);

export const adminCreateBranch = (data) => client.post('/admin/branches', data).then((r) => r.data);
export const adminUpdateBranch = (id, data) => client.post(`/admin/branches/${id}`, data).then((r) => r.data);
export const adminDeleteBranch = (id) => client.post(`/admin/branches/${id}/delete`).then((r) => r.data);

export const adminSummary = () => client.get('/admin/analytics/summary').then((r) => r.data);
export const adminEvents = (limit = 50) => client.get('/admin/analytics/events', { params: { limit } }).then((r) => r.data);
export const adminResetAnalytics = () => client.post('/admin/analytics/reset').then((r) => r.data);

export const adminUpdateSettings = (data) => client.post('/admin/settings', data).then((r) => r.data);
export const adminUpdateAccount = (data) => client.post('/admin/account', data).then((r) => r.data);

export { apiErrorMessage };
